module.exports = __webpack_public_path__ + "images/file_icons_v2/vcf-36e087db4891eb6856f6b328add27f58.svg";